import {
    Layout,
    Alert,
    Collapse,
    Form,
    AutoComplete,
    Input,
    Row,
    Col,
    Select,
    Checkbox,
    Button,
    message,
    Radio,
    Upload,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
export default function Approval({ users, handleApprovalChange, approval, removeApproval }) {
    const { Option } = Select;
    return (
        <div>
            {approval.map((item, index) => (
                <div className=" row">
                    <label className="col-md-3 col-sm-12">{item?.position}</label>
                    <div className="col-md-5 col-sm-12">
                        <Form.Item
                            name={index}
                            rules={[
                                {
                                    required: true,
                                    message: "Please input",
                                },
                            ]}>
                            <Select
                                placeholder="Select an option"
                                showSearch
                                optionFilterProp="children"
                                onChange={(value) => handleApprovalChange(index, value)}

                            >
                                {users.map((user) => (
                                    <Option key={user?.employee_id} value={user?.employee_id}>
                                        {user?.fullname} / ({user?.employee_id})
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-md-2 col-sm-12">
                        <Button
                            type="text"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => removeApproval(index)}
                        />
                    </div>
                </div>
            ))}
            
        </div>
    );
}